<!--
무자료 수동등록 > 메인 컴포넌트
------------------------------------
-->
<template>
    <div class="split-wrap">
        <div id="split-1" class="split">
            <!-- 상품추가 -->
            <add-prod
                v-show="mode === 'add'"
                ref="add"

                :csrf-token="csrfToken"
                :region-id="regionId"
                :login-user-id="loginUserId"
                :login-user-name="loginUserName"

                :region-member-options="regionMemberOptions"
                :session-owner="sessionOwner"

                @added="prod => listenAdded(prod)"
            ></add-prod>

            <!-- 상품수정 컴포넌트 -->
            <update-prod
                v-show="mode === 'update'"
                ref="update"

                :csrf-token="csrfToken"
                :region-id="regionId"
                :login-user-id="loginUserId"
                :login-user-name="loginUserName"

                :region-member-options="regionMemberOptions"
                :session-owner="sessionOwner"


                @click:cancel-update="prod => listenCloseEditMode(prod)"
                @updated="prod => listenUpdated(prod)"
            >
            </update-prod>

            <!-- 상품삭제 컴포넌트 -->
            <remove-prod
                v-show="mode === 'remove'"
                ref="remove"

                :csrf-token="csrfToken"
                :region-id="regionId"
                :login-user-id="loginUserId"
                :login-user-name="loginUserName"

                :region-member-options="regionMemberOptions"
                :session-owner="sessionOwner"


                @click:cancel-remove="prod => listenCloseEditMode(prod)"
                @removed="prod => listenRemoved(prod)"
            >
            </remove-prod>
        </div>

        <!-- 구분선 -->
        <div id="gutter-1"></div>


        <!-- 컨텐츠 영역 -->
        <div id="split-2" class="split uk-flex uk-flex-column uk-flex-between uk-flex-stretch uk-height-1-1">
            <h3>
                <i class="material-icons md-36">list</i>
                <span class="uk-text-middle">오늘 무자료 등록내역({{ prods.length }})</span>
            </h3>
            <div class="uk-height-1-1 uk-overflow-auto list">
                <table>
                    <colgroup>
                        <col style="width: 8rem">
                        <col style="width: 16rem">


                        <col style="width: 30rem">
                        <col style="width: 6rem">
                        <col style="width: 8rem">

                        <col>
                        <col style="width: 10rem">

                        <col style="width: 6rem">
                        <col style="width: 6rem">

                    </colgroup>

                    <thead>
                    <tr>


                        <th scope="col" class="uk-text-center">
                            상품번호
                        </th>
                        <th scope="col" class="uk-text-left">

                            <div><i class="material-icons uk-text-muted">mail</i> 회원사서함</div>
                            <div><i class="material-icons uk-text-muted">person</i> 수취인이름</div>
                        </th>

                        <th scope="col" class="uk-text-left">
                            <div class="uk-text-bold"><i class="material-icons uk-text-muted">local_shipping</i> 트래킹번호</div>
                            <div><i class="material-icons uk-text-muted">info</i> 상품명</div>
                        </th>
                        <th scope="col" class="uk-text-center">
                            수량
                        </th>
                        <th scope="col" class="uk-text-center">
                            사이즈
                        </th>


                        <th scope="col" class="uk-text-left">
                            <div><i class="material-icons uk-text-muted">info</i> 색상</div>
                            <div><i class="material-icons uk-text-muted">info</i> 유통기한</div>
                        </th>
                        <th scope="col" class="uk-text-center">
                            보관장소
                        </th>

                        <th scope="col" class="uk-text-center">
                            수정
                        </th>
                        <th scope="col" class="uk-text-center">
                            삭제
                        </th>

                    </tr>
                    </thead>
                    <tbody>
                    <prod
                        v-for="prod in prods"
                        :key="prod.id"

                        :csrf-token="csrfToken"
                        :region-id="regionId"
                        :login-user-id="loginUserId"
                        :login-user-name="loginUserName"

                        :region-member-options="regionMemberOptions"
                        :session-owner="sessionOwner"

                        :prod="prod"
                        :selected-prod-id="selectedProdId"
                        :mode="mode"

                        @click:update="prod => listenClickUpdate(prod)"
                        @click:cancel-update="prod => listenCloseEditMode(prod)"
                        @click:remove="prod => listenClickRemove(prod)"
                        @click:cancel-remove="prod => listenCloseEditMode(prod)"
                    >

                    </prod>
                    </tbody>
                </table>
            </div>
        </div>



    </div>
</template>

<script>

    export default {
        components: {
            'add-prod': require('./add-prod.vue').default,
            'update-prod': require('./update-prod.vue').default,
            'remove-prod': require('./remove-prod.vue').default,
            'prod': require('./prod.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 로그인 유저 ID
             **/
            loginUserId: {
                type: Number,
                default: null,
            },


            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 사용자명
             */
            loginUserName: {
                type: String,
                default: null,
            },

        },
        data: function () {
            return {
                /**
                 * 등록된 상품정보 배열
                 */
                prods: [],

                /**
                 * 등록한 상품정보를 저장할 쿠키명
                 */
                cookieName: null,

                // (array) 지역 회원사 옵션
                regionMemberOptions: [],

                // (int) 업로드모듈에서 사용할 로그인ID
                sessionOwner: null,

                // 작성모드 (add, update, remove)
                mode: 'add',

                // 선택된 상품번호(수정, 삭제 등..)
                selectedProdId: null,
            };
        },
        mounted: function () {


            // 스플릿 레이아웃 사이즈 로컬스토리지에 저장
            let storage_key = 'nodata-stocks-split-sizes';
            let sizes = localStorage.getItem(storage_key)

            if (sizes) {
                sizes = JSON.parse(sizes)
            } else {
                sizes = [35, 65] // default sizes
            }

            // 스플릿 레이아웃 처리
            Split(['#split-1', '#split-2'], {
                sizes: sizes,
                gutterSize: 6,
                gutter: (index, direction) => {
                    const gutter = $('#gutter-1').get(0);
                    gutter.className = `gutter gutter-${direction}`;
                    return gutter;
                },
                onDragEnd: function (sizes) {
                    localStorage.setItem(storage_key, JSON.stringify(sizes))
                },
            });

            // 초기데이터 조회
            this.loadInitDate();

            // 오늘날짜에 대한 쿠키명
            let today = new Date();
            let year = today.getFullYear();
            let month = ('0' + (today.getMonth() + 1)).slice(-2);
            let day = ('0' + today.getDate()).slice(-2);
            let dateString = year + '-' + month  + '-' + day;
            this.cookieName = 'nodata-stocks-prod-ids-' + dateString;

            // 목록조회
            this.loadProdsFromCookie();


        },
        computed: {

        },
        methods: {
            /**
             * 상품추가 이벤트 리스너
             * @param prod
             */
            listenAdded(prod) {
                // 리스트에 추가
                this.prods.unshift(prod);

                // 쿠키갱신
                this.refreshCookie();

            },

            /**
             * 수정폼 이벤트 리스너
             * @param prod
             */
            listenClickUpdate(prod) {
                this.mode = 'update';
                this.$refs.update.show(prod);
                this.selectedProdId = prod.id;

            },

            /**
             * 삭제폼 이벤트 리스너
             * @param prod
             */
            listenClickRemove(prod) {
                this.mode = 'remove';
                this.$refs.remove.show(prod);
                this.selectedProdId = prod.id;

            },

            /**
             * 수정,삭제 폼 닫기 이벤트 리스너
             * @param prod
             */
            listenCloseEditMode(prod) {
                this.mode = 'add';
                this.$refs.add.init();
                this.selectedProdId = null;
            },

            /**
             * 상품삭제 이벤트 리스너
             * @param prod
             */
            listenRemoved(prod) {
                // 리스트에 제거
                let key = _.findIndex(this.prods, {id: prod.id});
                if (key < 0) {
                    alert('제거할 index of array 를 찾지 못했습니다');
                } else {
                    this.prods.splice(key, 1);
                }

                // 쿠키갱신
                this.refreshCookie();

                // 편집모드 종료
                this.listenCloseEditMode(prod);
            },

            /**
             * 상품수정 이벤트 리스너
             * @param prod
             */
            listenUpdated(prod) {
                // 리스트에서 교체
                let key = _.findIndex(this.prods, {id: prod.id});
                if (key < 0) {
                    alert('교체할 index of array 를 찾지 못했습니다');
                } else {
                    this.prods.splice(key, 1, prod);
                }

                // 쿠키갱신
                this.refreshCookie();

                // 편집모드 종료
                this.listenCloseEditMode(prod);
            },

            /**
             * 쿠키를 최신상태로 갱신
             */
            refreshCookie() {
                let prod_ids = _.map(this.prods, 'id');
                Cookies.set(this.cookieName, JSON.stringify(prod_ids), { expires: 1 });
            },

            /**
             * 쿠키에 저장된 상품번호로 목록을 조회
             */
            loadProdsFromCookie() {
                // 쿠키에 저장된 목록 불러오기
                let stringfy = Cookies.get(this.cookieName);
                if (! stringfy) {
                    return;
                }

                let prod_ids = JSON.parse(stringfy);
                if ((! prod_ids) || prod_ids.length === 0) {
                    return;
                }

                // promise 생성
                let p = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/regions/' + this.regionId + '/nodata-stocks/registered-prods',
                        data: {
                            //'_token': this.csrfToken,
                            prod_ids: prod_ids,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: (jqXHR, textStatus, errorThrown) => {
                            // promise 실패
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                p.then((response) => {
                    // 결과저장
                    this.prods = response.prods;

                }).catch(() => {
                });
            },


            /**
             * 초기필요정보 조회
             */
            loadInitDate() {
                // promise 생성
                let p = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/regions/' + this.regionId + '/nodata-init-data',
                        data: {
                            //'_token': this.csrfToken,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: (jqXHR, textStatus, errorThrown) => {
                            // promise 실패
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                p.then((response) => {
                    // 결과저장
                    this.regionMemberOptions = response.region_member_options;
                    this.sessionOwner = response.session_owner;

                }).catch(() => {
                    this.cancel();
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
    .split-wrap {
        display: flex;
        flex-direction: row;
        height: 100%;

        .split {
            height: 100%;

            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;

            overflow-y: auto;
            overflow-x: hidden;
        }

        #split-1 {
            min-width: 500px;
        }
        .gutter {
            background-color: #344766;

            background-repeat: no-repeat;
            background-position: 50%;
        }

        .gutter.gutter-horizontal {
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==');
            cursor: col-resize;
        }

        .gutter.gutter-vertical {
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFAQMAAABo7865AAAABlBMVEVHcEzMzMzyAv2sAAAAAXRSTlMAQObYZgAAABBJREFUeF5jOAMEEAIEEFwAn3kMwcB6I2AAAAAASUVORK5CYII=');
            cursor: row-resize;
        }
    }

    h3 {
        margin: 1rem 0 0 1rem;
        font-size: 1.25rem;
        font-weight: bold;
    }

    .header {

    }
    .list {
        margin: 0 1rem;
        //padding: 1rem;
        background-color: #eaeaea;
        border: 1px solid #999;

        table {
            width: 100%;
            border-collapse: collapse;
            table-layout: fixed;

            th {
                padding: 0.25rem;
                border: 1px solid #cfcfcf;
                background-color: #fafafa;
                font-size: 1.25rem;
                font-weight: normal;
            }
        }
    }


</style>